import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Brands from '../../brands/brands';
import Heading from '../../heading/heading';

const BrandsBlock = ({ paddingTop, paddingBottom, heading, ...props }) => {
  return (
    <Container size={'lg'} gutters>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        <Spacing pt={0} pb={2}>
          <Heading tag={2} text={heading} size={'lg'} animate />
        </Spacing>
        <Brands {...props} name={props.__typename} />
      </Spacing>
    </Container>
  );
};

export default BrandsBlock;

export const query = graphql`
  fragment BrandsBlock on DatoCmsBrandsBlock {
    id: originalId
    paddingTop
    paddingBottom
    heading
    items {
      logo {
        alt
        url
      }
    }    
    __typename
  }
`;
